import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Devops Cloud Engineer",
          "Google-Certified Professional Cloud DevOps Engineer",          
          "AWS Devops Certified Professional",          
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
